import ID from './ID'
import Initiative from './Initiative'

export default class InitiativeType {
  constructor(
    public id: ID = new ID(),
    public creatorId: ID = new ID(),
    public name: string = '',
    public description: string = '',
    public initiativeChannelId: ID = new ID(),
    public orderIndex: number = 0,
    public isNested: boolean = false,
    public isLead: boolean = false,

    public initiatives: Initiative[] = [], //Populated on front-end
    public channelName: string = '', //Populated on front-end
    public abbreviatedPlanName: string = '' //Populated on front-end
  ) {}

  public static INITIATIVE_TYPE_NAME_CAMPAIGN = 'campaign'
  public static INITIATIVE_TYPE_NAME_PROMOTION = 'promotion'
  public static INITIATIVE_TYPE_NAME_KEY_DATE = 'key date'
  public static INITIATIVE_TYPE_NAME_MONTHLY_THEME = 'monthly theme'

  public get key() {
    return 'initiative-type-' + this.id.intID.toString()
  }

  public get hasInitiatives(): boolean {
    if (this.initiatives.length) {
      return true
    }
    return false
  }

  public static fromResponseObject(obj): InitiativeType {
    if (!obj) return new InitiativeType()

    return new InitiativeType(
      ID.fromResponseObject(obj.id, 'initiative_types'),
      ID.fromResponseObject(obj.creator, 'users'),
      obj.name,
      obj.description,
      ID.fromResponseObject(obj.initiativeChannel, 'initiative_channels'),
      obj.orderIndex,
      obj.isNested,
      obj.isLead,
    )
  }

  public forRequestObject() {
    return {
      id: this.id.intID == 0 ? null : this.id.apiID,
      creator: this.creatorId.intID == 0 ? null : this.creatorId.apiID,
      name: this.name,
      description: this.description,
      initiativeChannel: this.initiativeChannelId.intID == 0 ? null : this.initiativeChannelId.apiID,
      orderIndex: this.orderIndex,
    }
  }
}
